<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { DisagreementsDialogViewModel } from '@Evaluation/Estimations/Components/DisagreementsDialog'
    import type { DisagreementItem } from '@Evaluation/Estimations/Domain/readmodels'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: DisagreementsDialogViewModel
    }>()

    const emit = defineEmits<{
        (e: 'switch-question', questionId: string): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened)
    const initialized = computed(() => vm.value.initialized)
    const questions = computed(() => vm.value.questions)

    // ---------------- actions ----------------

    function switchQuestion(q: DisagreementItem)
    {
        emit('switch-question', q.QuestionId)
        close()
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Disagreements</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">

                        <h3 v-if="!initialized">
                            <i class="fa fa-spinner fa-spin"></i> Loading...
                        </h3>

                        <div v-if="initialized" class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>
                                            Alternative
                                        </th>
                                        <th>
                                            Attribute
                                        </th>
                                        <th>
                                            Disagreement
                                        </th>
                                        <th>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="q in questions" :key="q.QuestionId">
                                        <td>
                                            {{q.AlternativeName}}
                                        </td>
                                        <td>
                                            {{q.AttributeName}}
                                        </td>
                                        <td>
                                            {{q.DisagreementLabel}}
                                        </td>
                                        <td class="text-center">
                                            <a class="text-primary" @click="switchQuestion(q)">show</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>